enum Env {
  DEV = 'development',
  TEST = 'test',
  PREVIEW = 'preview',
  PRODUCTION = 'production'
}

export default Env
